module.exports = __webpack_public_path__ + "58f7fd41daec51e3a319ade873186154.png";